import { render, staticRenderFns } from "./HorizontalButtons.vue?vue&type=template&id=1cbaf2c8&"
import script from "./HorizontalButtons.vue?vue&type=script&lang=js&"
export * from "./HorizontalButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports